import { operatorClient } from 'domain/HttpClients';

export const save = (shipperId, data) => operatorClient
  .Patch(`/api/pricing/discounts/${shipperId}`)
  .withData(data)
  .send();
